import * as React from 'react';

import { StyleSheet } from 'aphrodite/no-important';
import { Ad } from '../ads/Ad';
import { AdditionalStyleSheet, OptionalAdditionalStyle } from '../components.utils';
import { ErrorBoundary } from '../errorHandling/ErrorBoundary';
import { BlockWidths } from '../components/pageLayouts/BlockTypes.utils';
import { createBlockStyle } from './blockMutualStyle';

interface ArticleAdDataProps {
  id: string | null;
  defaultBlocksWidths: BlockWidths;
  dataId: string;
}

type ArticleAdProps = ArticleAdDataProps & OptionalAdditionalStyle;

const getStyle = (defaultBlocksWidths: BlockWidths) => {
  return StyleSheet.create({
    style: {
      ...createBlockStyle(defaultBlocksWidths),
    },
  }) as AdditionalStyleSheet;
};
export const ArticleAd: React.FunctionComponent<ArticleAdProps> = props => {
  const { defaultBlocksWidths } = props;
  const additionalStyle = getStyle(defaultBlocksWidths);
  return <ErrorBoundary><Ad {...props} additionalStyle={additionalStyle} onSuccess={null} /></ErrorBoundary>;
};
